import CardCommon from '@op/components/CardCommon';
import React, { useMemo, useState } from 'react';
import TableCommonHook from '@op/components/TableCommonHook';
import useCompareKeyMetricsColumns from '@op/components/TableCommonHook/hooks/useCompareKeyMetricsColumns';
import { dealwithMentionsSentimentTable, getGameColorOrName } from '../utils';
import { useCompareKeyMetricsTable } from '../hooks';
import { SortBy } from 'tea-component/lib/table/addons';
import useLanguage from '@op/hooks/useLanguage';
import { useDownloadParams } from '@op/hooks/useDownloadParams';
import { TableHeight } from '../constants';

export default function PRTable({
  filter,
  gameData,
}: {
  filter: any;
  gameData: {
    [id: string]: {
      name: string;
      color: string;
    };
  }[];
}) {
  const [sorts, setSorts] = useState<SortBy<any>>({
    by: '',
    order: 'desc',
  });

  const { downloadLegacy, downloading } = useDownloadParams();

  const params = useMemo(
    () => ({
      ...filter,
      stats_types: ['pr'],
      tab_type: 'pr',
      by_type: 'pr',
    }),
    [filter],
  );

  const { tableRecords, loading } = useCompareKeyMetricsTable({
    filter: params,
    dealwithToTable: dealwithMentionsSentimentTable,
    gameData,
    defaultSortKey: 'all_articles',
  });

  const { columns, sortColumns } = useCompareKeyMetricsColumns({
    oneKey: 'PR',
    gameData,
    tableRecords,
    filter,
  });

  return (
    <CardCommon
      contentCard
      className="mentions-sentiment-table-wrapper"
      hasDownload
      loading={loading}
      loadingHeight={265}
      downloadLoading={downloading}
      handleDownloadOnClick={() => {
        downloadLegacy({
          params: {
            ...params,
            gameData,
          },
          downloadFunc: 'getOverviewCompetitorTable',
          sheetName: 'Compare Key Metrics PR Table',
          simpleName: 'Compare Key Metrics PR Table',
        });
      }}
      logBtnId="PR Table"
    >
      <TableCommonHook
        bordered="all"
        columns={columns}
        hasPageable={false}
        maxHeight={TableHeight.BELOW}
        sortColumns={sortColumns}
        records={tableRecords}
        defaultSort={sorts}
        sortType={'local'}
        minWidth={'auto'}
        sortInfo={[sorts, setSorts]}
        logBtnId="PR"
      ></TableCommonHook>
    </CardCommon>
  );
}
